import { checkoutWidgetsSchema } from "@redotech/redo-model/checkouts/checkout-widgets-builder";
import { CheckoutOptimizationWidgetType } from "@redotech/redo-model/checkouts/widget";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

const createCheckoutWidgetInputSchema_ = z.object({
  widgetType: createEnum(CheckoutOptimizationWidgetType),
  widgetData: checkoutWidgetsSchema,
});

export const createCheckoutWidget = {
  name: "createCheckoutWidget" as const,
  description:
    "Creates a checkout optimization widget for the authenticated team and returns its ID. Pass the widget's type in `widgetType` and its configuration under the matching key of `widgetData` (e.g. widgetData[THRESHOLD_UPSELL] for widgetType THRESHOLD_UPSELL); the entry must include `target` and type-specific fields. The new widget is not assigned to any checkout experience — assign it separately (e.g. via assignWidgetsToExperience).",
  input: createCheckoutWidgetInputSchema_,
  output: zExt.objectId(),
};
